import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import dayjs from "dayjs";

import { DatePicker } from "antd";

import "./DateTimeField.scss";

export class DateTimeField extends React.Component {
  static defaultProps = {
    defaultValue: undefined,
    disabled: false,
  };

  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    locale: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.string,
    ]),
    onOk: PropTypes.func,
    open: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    let inputDateValue = props.defaultValue;
    if (!inputDateValue) {
      inputDateValue = new Date();
    }

    this.state = {
      value: dayjs(inputDateValue),
    };
  }

  onOk = (event) => {
    const { onOk } = this.props;
    if (onOk) {
      onOk(event);
    }
  };

  onChange = (value) => {
    const { id, onChange } = this.props;
    this.setState({ value });

    let dateValue;
    if (value) {
      dateValue = value.toDate();
    }

    if (onChange) {
      if (id) {
        return onChange({
          id,
          value: dateValue,
        });
      }
      return onChange(dateValue);
    }
    return value;
  };

  render() {
    const { value } = this.state;
    const { className, disabled, id, label, locale, open } = this.props;

    const fieldClass = classNames("DateTimeField__Wrapper", className);

    return (
      <div className={fieldClass} data-testid="dateTimeFieldWrapper">
        {label && <label htmlFor={id}>{label}</label>}
        <DatePicker
          defaultValue={value}
          id={id}
          locale={locale}
          showTime
          disabled={disabled}
          open={open}
          onOk={this.onOk}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

export default DateTimeField;
